import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["select"]

    connect() {
    }

    filter() {
        const segmentToLoadValue = this.selectTarget.value

        const url = `/segments/${segmentToLoadValue}/load`
        if (segmentToLoadValue) {
            // Use fetch to get the filtered results
            fetch(url, {
                headers: {
                    "Accept": "text/vnd.turbo-stream.html",
                    "X-Requested-With": "XMLHttpRequest"
                }
            })
                .then(response => response.text())
                .then(html => {
                    Turbo.renderStreamMessage(html)
                })
                .catch(error => {
                    console.error("Error fetching filtered results:", error)
                })
        }
    }
}
